import { EntityServiceAdapter, QueryParams, QueryResult } from '../../../types/baseExplorerConfig';
import { HotspotEntity } from '../../../types/hotspot';
import { hotspotService } from '../../../services/hotspotService';
import { objectToSearchParams } from '../baseExplorer/objectToSearchParams';
import { backendPage, pageHasMore } from '../../../utils/pagination';

const NUMERIC_FIELD_MAP: Record<string, { min: string; max: string }> = {
  brightness: { min: 'minBrightness', max: 'maxBrightness' },
  frp: { min: 'minFrp', max: 'maxFrp' },
  lat: { min: 'minLat', max: 'maxLat' },
  lon: { min: 'minLon', max: 'maxLon' },
};

function translateParams(params: QueryParams): Record<string, any> {
  const out: Record<string, any> = {};

  if (params?.sort?.[0]) {
    out.sortBy = params.sort[0].field;
    out.sortOrder = params.sort[0].direction;
  }

  if (!params?.filters) return out;

  for (const filter of params.filters) {
    if (filter.field === 'acqDatetime') {
      if (filter.operator === 'gte' && filter.value) {
        out.startDate = new Date(filter.value + 'T00:00:00').toISOString();
      } else if (filter.operator === 'lte' && filter.value) {
        out.endDate = new Date(filter.value + 'T23:59:59.999').toISOString();
      }
      continue;
    }
    if (filter.field === 'confidence') { out.confidence = filter.value; continue; }
    if (filter.field === 'source') { out.source = filter.value; continue; }
    if (filter.field === 'ageClass') { out.ageClass = filter.value; continue; }

    const mapping = NUMERIC_FIELD_MAP[filter.field];
    if (mapping) {
      const nv = filter.value as { operator: string; value?: number; value2?: number };
      if (!nv?.operator) continue;
      if (nv.operator === 'between') {
        if (nv.value != null) out[mapping.min] = nv.value;
        if (nv.value2 != null) out[mapping.max] = nv.value2;
      } else if (nv.operator === 'gte') {
        if (nv.value != null) out[mapping.min] = nv.value;
      } else if (nv.operator === 'lte') {
        if (nv.value != null) out[mapping.max] = nv.value;
      } else if (nv.operator === 'eq' && nv.value != null) {
        out[mapping.min] = nv.value;
        out[mapping.max] = nv.value;
      }
    }
  }

  return out;
}

export const hotspotServiceAdapter: EntityServiceAdapter<HotspotEntity> = {
  async fetchData(params: QueryParams): Promise<QueryResult<HotspotEntity>> {
    try {
      const serviceParams: any = {
        ...backendPage(params),
        ...translateParams(params),
      };

      const response = await hotspotService.fetchData(serviceParams);
      return {
        data: response.data.map((h: any) => ({
          ...h,
          _id: h._id || h.uniqueId || String(h.id),
        })),
        total: response.total,
        page: response.page,
        limit: response.limit,
        hasMore: pageHasMore(response.page, response.limit, response.total),
      };
    } catch (error) {
      console.error('Hotspot ServiceAdapter Error:', error);
      throw error;
    }
  },

  buildExportParams: (params: QueryParams) => objectToSearchParams(translateParams(params)),
};
